import { render, staticRenderFns } from "./StatisticsProgramProg.vue?vue&type=template&id=bea5b078&"
import script from "./StatisticsProgramProg.vue?vue&type=script&lang=js&"
export * from "./StatisticsProgramProg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports